import {
    getProduct,
    listProducts
} from './queries';
import {
    cloneProduct,
    createProduct,
    deleteProduct,
    updateProduct,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CloneProduct,
    CreateProduct,
    DeleteProduct,
    GetProduct,
    ListProducts,
    Product,
    UpdateProduct
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../components/PlatformNotification";
import { billingApiClient } from "../../billing-api-integration";
import {moduleConfig} from "../config";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;

const normalizeRecord = (record: Product) => {
    return Object.assign({}, record);
};


export const fetchRecords = async (query: ListRecordsQuery) => {

    try {
        const response = await client.graphql<GraphQLQuery<ListProducts>>({
                                                                              query: listProducts,
                                                                              variables: {
                                                                                  filter: { status: 'Active' },
                                                                                  ...query
                                                                              },
                                                                          });

        return {
            items: response.data?.listProducts.items?.map(item => normalizeRecord(item)) || [],
            nextToken: response.data?.listProducts.nextToken
        };

    } catch (e) {
        console.trace(e);
        notifyError(e);
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetProduct>>({
                                                                            query: getProduct,
                                                                            variables: {id: id},
                                                                        });
        return response.data?.getProduct;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateProduct>>({
                                                                               query: createProduct,
                                                                               variables: {input: payload},
                                                                           });
        notifySuccess(`${moduleConfig.titles.singular} created`);
        return response.data?.createProduct;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: Product) => {

    console.debug('IN UPDATE', id);

    delete record.created;
    delete record.updated;
    delete record.createdByUsername;
    delete record.createdByUser;
    delete record.lineItems;

    // Filter out null/undefined values
    const cleanRecord = Object.fromEntries(
        Object.entries(record).filter(([_key, value]) => value !== null && value !== undefined && value !== '')
    );

    try {
        const response = await client.graphql<GraphQLQuery<UpdateProduct>>({
                                                                               query: (updateProduct),
                                                                               variables: {input: cleanRecord},
                                                                           });
        notifySuccess(`${moduleConfig.titles.singular} updated`)
        return response.data?.updateProduct;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const cloneRecord = async (id: string) => {

    try {
        const response = await client.graphql<GraphQLQuery<CloneProduct>>({
                                                                              query: (cloneProduct),
                                                                              variables: {id: id},
                                                                          });
        notifySuccess(`${moduleConfig.titles.singular} cloned`)
        return response.data?.cloneProduct;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteProduct>>({
                                                                               query: (deleteProduct),
                                                                               variables: {input: {id: id}},

                                                                           });
        notifySuccess(`${moduleConfig.titles.singular} deleted`)
        return response.data?.deleteProduct;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
